exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-f2782562] .v-card{-webkit-box-shadow:none;box-shadow:none}[data-v-f2782562] .theme--dark .v-card__text{background:#212121!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f2782562","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/whitelabel/UserDeposits.vue
// module id = Btmt
// module chunks = 0